import { useSelector } from "react-redux";
import Table from "../table/Table";
import { StoreState } from "../../../../redux/storeState/storeState";
import axios from "axios";
import { useEffect, useState } from "react";
import moment from "moment";
interface PosDetailsIProp {
  setSelectedOption: any;
  headerData: any;
}
function IntegrationPosDetails({ setSelectedOption, headerData }: PosDetailsIProp) {
  const [pointOfSales, setPointOfSales] = useState<any>([]);
  const [page, setPage] = useState(0);
  const [size, setSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [stores, setStores] = useState<any>([]);
  const [selectedStore, setSelectedStore] = useState("all");

  const { companyInfo } = useSelector((state: StoreState) => ({
    companyInfo: state.companies.companySideInfoData,
  }));

  const fetchAllPos = async () => {
    if (companyInfo?.id) {
      let allPos = await axios.get(
        `/admin-company-pointOfSales/${companyInfo?.id}${page && page > 0 ? `?page=${page}` : "?page=1"}${
          searchText ? `&searchName=${searchText}` : ""
        }&sortAt=businessId&sortBy=desc${size && size > 0 ? `&size=${size}` : "&size=10"}`,
      );
      let refactoredPos = allPos?.data?.results?.map((item: any) => {
        const date = moment(item?.zatca?.expiresAt);
        const isAfterToday = date.isAfter(moment(), "day");
        return {
          ...item,
          id: item?.businessId,
          storeName: item?.store,
          status: item?.zatca?.certificateId?.length > 0 ? "Active" : "Inactive",
          type: item?.zatca?.certificateId?.length > 0 ? (item?.zatca?.useTestCSR ? "Simulation" : "Production") : "",
          expiresAt:
            !item?.zatca?.isExpired && item?.zatca?.expiresAt
              ? `${moment(item?.zatca?.expiresAt)?.format("DD MMM YYYY")} ${isAfterToday ? "(5 years)" : ""} `
              : item?.zatca?.isExpired
                ? "Expired"
                : "",
        };
      });
      setPointOfSales([...refactoredPos]);
      setTotal(allPos?.data?.totalResults);
      setPage(allPos?.data?.page);
      setSize(allPos?.data?.size);
    }
  };

  useEffect(() => {
    fetchAllPos();
    //eslint-disable-next-line
  }, [page, size, searchText]);

  const fetchAllStores = async () => {
    let response = await axios.get(`/admin-company-stores/${companyInfo?.id}?skipPagination=${true}`);
    let allStores = response?.data?.results?.map((item: any) => {
      return { ...item, isSelected: true, value: item?.businessId, name: item?.name };
    });
    let defaultStoreValue = { name: "All Stores", value: "all", isSelected: true };
    setStores([defaultStoreValue, ...allStores]);
  };

  useEffect(() => {
    fetchAllStores();
    //eslint-disable-next-line
  }, []);

  let handleChangeStores = async (option: any) => {
    if (option?.target.value !== "All Stores") {
      setSelectedStore(option?.target.value);
      let response = await axios.get(`/admin-company-pointOfSales/${companyInfo?.id}?skipPagination=${true}`);
      let filteredPos = response?.data?.results?.filter(
        (item: any) => String(item?.storeData?.storeId)?.trim() === String(option?.target?.value)?.trim(),
      );
      let refactoredPos = filteredPos?.map((item: any) => {
        return {
          ...item,
          id: item?.businessId,
          storeName: item?.store,
          status: item?.isActive ? "Active" : "Inactive",
        };
      });
      setPointOfSales([...refactoredPos]);
    } else {
      setSelectedStore("All Stores");
      await fetchAllPos();
    }
  };
  return (
    <div>
      <div className="main-overview-wrap">
        <div className="title-subscription">Companies &gt; {companyInfo?.businessName} &gt; Integration &gt; Zatca</div>
        <button
          className="back-btn"
          onClick={() => {
            setSelectedOption("integration");
          }}
        >
          Back
        </button>
      </div>

      <div className="mt-3">
        <Table
          setSelectedOption={setSelectedOption}
          tableHeadData={headerData}
          tableBodyData={pointOfSales}
          page={+page}
          size={size}
          setPage={setPage}
          setSize={setSize}
          total={total}
          handleSiteSearch={() => {}}
          handleArrowSortClick={() => {}}
          handleSort={() => {}}
          searchText={searchText}
          selectedSiteHeader={""}
          setsiteSearchText={setSearchText}
          subscriptionView={false}
          placeholder="Search integration"
          singleDetailPath={`integration_zatca_details`}
          resetHandler={() => {
            setSearchText("");
          }}
          stores={stores}
          handleChangeStores={handleChangeStores}
          selectedStore={selectedStore}
          showStoreSelector={true}
        />
      </div>
    </div>
  );
}

export default IntegrationPosDetails;
